import React, {Fragment} from 'react';
import {Button} from 'material-ui';
import {Props} from '../Builder/ElementProperties';

const ButtonElement = (props) => {


	let onClick = () => {
		props.experiment.recordEvent({eventType:'User Action', actionType:'click', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'button', value: props.element.text, expectedValue: props.element.expected });
		Props.onClickHandler({props, field:'onClick'});
	}
	
	let submitOnEnterClass = (!props.builder && props.element.submitOnEnter) ? 'submit-on-enter' : '';


	return (
		<Button 
			className={`button-element ${submitOnEnterClass}`}
			variant="raised"
			color="primary"
			style={{height: props.element.height + 'px'}}
			fullWidth
			onClick = {onClick}
			>
			{props.element.text}
		</Button>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.Text {...props} />
		<Props.Expected {...props} />
		<Props.OnClick {...props} />
		<Props.SubmitOnEnter {...props} />
	</Fragment>
);

ButtonElement.type = 'button';
ButtonElement.Properties = Properties;
ButtonElement.defaultJSON = {type: 'button', id:'New Button', x: 250, y:250, width:100, height:50, text:'Continue', expected: '', onClick:'{next}', submitOnEnter:true};
export default ButtonElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/ButtonElement.js